import React, {useState} from 'react';
import {connect} from 'react-redux';
import {SendRequest} from '../js/request-builder';
import { getDefaultMerchant } from '../../../../../lhs/reducers/configuration-reducer';
import CybsMenuButton from '@cybs-ui/components/lib/menu-button';
import CybsButton from '@cybs-ui/components/lib/button';



/**
 * 
 * This is the method to trigger send and download option
 * @param {*} event 
 * @param {*} selected 
 */
function handleSelectionSend(event, selected)
{
    if(selected !=null)
    {
        if(selected[0]!=null)
        {
            if(selected[0]["value"].toLowerCase() == "send")
            {
                SendRequest(false);
            }
            else if(selected[0]["value"].toLowerCase() == "send-and-download")
            {
                SendRequest(true);
            }
        }
    }
    else
    {
        SendRequest(false);
    }
};
class SendButtonInLiveConsoleTab extends React.Component
{

    render()
    {
        if(this.props.enabledDownload)
        {
            return (
            <CybsMenuButton
                id = "sendButton"
                buttonProps={{
                    colorScheme: 'secondary',
                    label: 'Send',
                    onButtonClick: (event, open) => {},
                    onButtonKeyDown: (event, open) => {},
                    variant: 'split',
                }}
                dataTest="basic-button-menu"
                items={[
                        {'label':'Send', 'value':'send'},
                        {'label':'Send and Download', 'value':'send-and-download'}
                        ]}
                onSelect={handleSelectionSend}
                className = "border_color_theme_primary"
                disabled={this.props.sendDisabled == "true" || (this.props.disableDefaultMerchantCreds == "true" && this.props.defaultMerchant)}
                // selectedItem={selectedItems}
                />);
                                        
        }
        else
        {   
            return (<CybsButton
                aria-label="Send button for the request body"
                aria-description="On click of this button the request call will be triggered"
                id = "sendButton"
                colorScheme="secondary"
                dataTest="left"
                i18n={{ ariaLabel: <b></b>, label: 'Send' }}
                onClick={() => SendRequest()}
                className = "border_color_theme_primary"
                disabled={this.props.sendDisabled == "true" || (this.props.disableDefaultMerchantCreds == "true" && this.props.defaultMerchant)}
            />);
        }
       
    }

}

function mapStateToProps(state){
    return{
      sendDisabled: (state.lhsReducer.sendDisabled == undefined)? false: state.lhsReducer.sendDisabled,
      enabledDownload: (state.lhsReducer.enabledDownload == undefined)? false: state.lhsReducer.enabledDownload,
      defaultMerchant: (state.configurationReducer.defaultMerchant == undefined)? true : state.configurationReducer.defaultMerchant,
      disableDefaultMerchantCreds: (state.lhsReducer.disableDefaultMerchantCreds == undefined) ? "false": state.lhsReducer.disableDefaultMerchantCreds
    }
}

export default connect(mapStateToProps)(SendButtonInLiveConsoleTab);